import { render, staticRenderFns } from "./OrderClose.vue?vue&type=template&id=2df578c1&"
import script from "./OrderClose.vue?vue&type=script&lang=js&"
export * from "./OrderClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports